import React, { useEffect, useState, Fragment } from 'react';
import { Redirect } from 'react-router-dom';
import { makeStyles, withStyles } from '@material-ui/core/styles';

import { tagSchemaObject } from '../TagAmendmentSchema'

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

import Button from '@material-ui/core/Button';
import services from '../services';
import MenuItem from '@material-ui/core/MenuItem';
import { Fields, validateProperty, validate } from "../../Common"
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import CardActions from '@material-ui/core/CardActions';
import { initial } from 'lodash';


const useStyles = makeStyles((theme) => ({
    root: {
        minWidth: 275,
        fontSize: 10,
    },
    tabroot: {
        flexGrow: 1
    },
    title: {
        fontSize: 12,
    },
    pos: {
        marginBottom: 12,
    },
    btncolor: {
        background: '#10BA57'
    },
    btnroot: {
        backgroundColor: '#10BA57',
        borderRadius: 3,
        border: 0,
        color: 'white',
        height: '30px',
        padding: '0 30px',
        boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
        "&:hover": {
            //you want this to be the same as the backgroundColor above
            backgroundColor: "#049C44"
        }

    },
    btnrootReject: {
        backgroundColor: '#FFA500',
        borderRadius: 3,
        border: 0,
        color: 'white',
        height: '30px',
        padding: '0 30px',
        boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
        "&:hover": {
            //you want this to be the same as the backgroundColor above
            backgroundColor: "#049C44"
        }

    },
    btnrootdel: {
        backgroundColor: '#FF0000',
        borderRadius: 3,
        border: 0,
        color: 'white',
        height: '30px',
        padding: '0 30px',
        boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
        "&:hover": {
            //you want this to be the same as the backgroundColor above
            backgroundColor: " #e60000"
        }

    },
    colorscheme: {
        color: '#10BA57',
    },

    card: {
        alignContent: 'center'
    },

    label: {
        textTransform: 'capitalize',
    },
    rootpaper: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        listStyle: 'none',
        padding: theme.spacing(0.5),
        margin: 0,
    },
    chip: {
        margin: theme.spacing(0.5),
    },
    dialogWidth: {
        width: "1000px"
    }
}));




export function TagAmendmentApprovalListing(props) {
    const classes = useStyles();
    const [searchData, setSearchData] = useState({
        groupID: "0",
        operationEntityID: "0",
        tag: " ",
        date: ""
    });
    const [errors, setErrors] = useState({});
    const [groups, setGroups] = useState();
    const [factoriesData, setFactoriesData] = useState();

    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Success"
    })
    const [value, setValue] = React.useState(0);
 
    const schema = Joi.object(tagSchemaObject).options({ allowUnknown: true });

    const [tagDetails, setTagDetails] = useState({
        routeCode:"",
        routeName: "",
        date: "",
        customerNo:"",
        customerID:"",
        cardNumber: "",
        supplierRegNo: "",
        grossAmount: "",
        actualAmount: "",
        netAmount: "",
        createdDate:"",
        deductions: []
    });

    const [updateTagDetails, setUpdateTagDetails] = useState({
        routeCode:"",
        routeName: "",
        date: "",
        customerNo:"",
        customerID:"",
        cardNumber: "",
        supplierRegNo: "",
        grossAmount: "",
        actualAmount: "",
        netAmount: "",
        createdDate:"",
        deductions: []
    });

    const [initialTag, setInitialTag] = useState({});

    const [viewTable, setViewTable] = React.useState(true);
    const [deductionTemplate, setDeductionTemplate] = React.useState({
        deductions:[]
    });
    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, tagSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];
        setErrors(error);
    }




    useEffect(() => {
        setGroupDropDownData();
        var datex = (new Date().toISOString()).split("T");
        setSearchData({
            ...searchData,
            date: datex[0]
        });

    }, []);

    async function setGroupDropDownData() {
        const result = await services.getGroupsForDropdown()
        setGroups(result)
    }

    async function getOperationEntitiesForDropdown(groupID) {
        const opEntities = await services.getAllOperationEntitiesForDropDown(groupID);
        setFactoriesData(opEntities);
    }


    function handleGroupChange(target) {
        validateInputs(target);
        setSearchData({
            ...searchData,
            groupID: target.value
        });
        getOperationEntitiesForDropdown(target.value);
    }

    function handleOperationEntityChange(target) {
        validateInputs(target);
        setSearchData({
            ...searchData,
            operationEntityID: target.value,
        });
       
    }

    function handleTagChange(target) {
        validateInputs(target);
        setSearchData({
            ...searchData,
            tag: target.value,
        });
    }

    function handleSearchDateChange(target) {
        setSearchData({
            ...searchData,
            date: target.value,
        });
    }

    function renderDropDown(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items;
    }

    async function handleSubmit() {
        let formdata = {
            operationEntityID: parseInt(searchData.operationEntityID),
            searchDate: searchData.date,
            tagNo: searchData.tag
        }
        var res = await services.getTagAmendmentRequests(formdata);
        console.log("details", res);
        if(res != null){

            setViewTable(false);
            setUpdateTagDetails({
                ...updateTagDetails,
                routeName : res.oldCollectionRequestJson.routeName,
                routeCode: res.oldCollectionRequestJson.routeCode,
                createdDate : res.newDate,
                customerNo : res.cnum,
                cardNumber:res.cardNumber,
                actualAmount:res.actualAmount,
                netAmount:res.netAmount,
                grossAmount:res.grossAmount,
            })

            setTagDetails({
                ...tagDetails,
                routeName : res.oldCollectionRequestJson.routeName,
                routeCode: res.oldCollectionRequestJson.routeCode,
                createdDate : res.oldCollectionRequestJson.weightReadTime,
                customerNo : res.oldCollectionRequestJson.customerNo,
                cardNumber:res.oldCollectionRequestJson.cardNumber,
                actualAmount:res.oldCollectionRequestJson.actualAmount,
                netAmount:res.oldCollectionRequestJson.netAmount,
                grossAmount:res.oldCollectionRequestJson.grossAmount,
            })

            setDeductionTemplate({
                ...deductionTemplate,
                deductions:res.newDeduction
            })

            setInitialTag(res);

       
        }else{
            setViewTable(true);
        }
       
    }

   
    async function handleApprove() {
        var response = await services.approve(initialTag);
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
        afterSuccessfulyChanged(response.statusCode);
        await handleSubmit();
    }

    async function handleReject() {
        let formdata={
            requestId :initialTag.productCollectionEditRequestID,
            requestStatus:3
        }

        var response = await services.reject(formdata);
        setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message })
        afterSuccessfulyChanged(response.statusCode);
        await handleSubmit();
    }


    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            setTimeout(() => {
                modalDismissHandler();
            }, 3000);
        }
        setTimeout(() => {
            modalDismissHandler();
        }, 3000);
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true })
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    function handleTagChange(target) {
        validateInputs(target);
        setSearchData({
            ...searchData,
            tag: target.value,
        });
    }

    function handleSearchDateChange(target) {
        setSearchData({
            ...searchData,
            date: target.value,
        });
    }




    return (
        <Fragment>
         
                <Card className={classes.root}>

                    <CardContent>
                        <PageHeader
                            title={"Field Tag Amendment Approval"}
                            isButtonEnable={false}
                            buttonText="Back to Listing"
                            path="/leafamendRequest"
                        />
                        <form className={classes.root} noValidate autoComplete="off">
                            <Grid container spacing={3}>

                                <Grid item xs={3} >
                                    <TextField
                                        id="groupID"
                                        name="groupID"
                                        select
                                        fullWidth
                                        label="Group *"
                                        value={searchData.groupID}
                                        onChange={(e) => handleGroupChange(e.target)}
                                    >
                                        <MenuItem value="0">--Select Group Name--</MenuItem>
                                        {renderDropDown(groups)}
                                    </TextField>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </Grid>

                                <Grid item xs={3}>
                                    <TextField
                                        id="operationEntityID"
                                        name="operationEntityID"
                                        select
                                        fullWidth
                                        label="Factory *"
                                        onChange={(e) => handleOperationEntityChange(e.target)}
                                        value={searchData.operationEntityID}
                                    >
                                        <MenuItem value="0">--Select operationEntity Name--</MenuItem>
                                        {renderDropDown(factoriesData)}
                                    </TextField>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                </Grid>

                                <Grid item xs={3}>
                                    <TextField
                                        id="tag"
                                        name="tag"
                                        fullWidth
                                        label="TagNumber *"
                                        onChange={(e) => handleTagChange(e.target)}
                                        value={searchData.tag}
                                    >
                                    </TextField>
                                    {errors["tag"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["tag"]}</FormHelperText>}
                                </Grid>


                                <Grid item xs={3}>
                                    <TextField
                                        id="date *"
                                        fullWidth
                                        type="date"
                                        label="Date"
                                        onChange={(e) => handleSearchDateChange(e.target)}
                                        value={searchData.date}
                                    >

                                    </TextField>
                                </Grid>

                                <Grid container justify="flex-end">
                                    <Button
                                        onClick={() => handleSubmit()}
                                        variant="contained"
                                        className={classes.btnroot}
                                    > Search</Button>
                                </Grid>

                            </Grid>
                        </form>
                        <br />
                        <br />

                        <TableContainer component={Paper} hidden={viewTable}>
                                <Table className={classes.table} aria-label="simple table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{background:"lightgreen"}} >Field Name</TableCell>
                                            <TableCell align="center" style={{background:"lightgreen"}}>Original Record</TableCell>
                                            <TableCell align="center" style={{background:"lightgreen"}}>Updated Record</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                              
                                        <TableRow>
                                            <TableCell align="center" component="th" scope="row">
                                               Route Code
                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField fullWidth inputProps={{style: { textAlign: 'center' }}}  id="outlined-basic" disabled value={tagDetails.routeCode} size="small" label="" variant="outlined" />

                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField fullWidth inputProps={{style: { textAlign: 'center' }}}  id="outlined-basic" disabled name="routeCode"  value={updateTagDetails.routeCode} size="small" label="" variant="outlined" />
                                            </TableCell>
                                        </TableRow>

                                        <TableRow>
                                            <TableCell align="center" component="th" scope="row">
                                            Route Name
                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField fullWidth inputProps={{style: { textAlign: 'center' }}}  id="outlined-basic" disabled value={tagDetails.routeName} size="small" label="" variant="outlined" />

                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField fullWidth inputProps={{style: { textAlign: 'center' }}}  id="outlined-basic" disabled  name="routeName" value={updateTagDetails.routeName} size="small" label="" variant="outlined" />
                                            </TableCell>
                                        </TableRow>

                                        <TableRow>
                                            <TableCell align="center" component="th" scope="row">
                                            Date
                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField fullWidth inputProps={{style: { textAlign: 'center' }}}  id="outlined-basic" type="date" disabled value={(tagDetails.createdDate).split("T")[0]} size="small" label="" variant="outlined" />

                                            </TableCell>
                                            <TableCell align="center">

                                                <TextField fullWidth inputProps={{ style: { textAlign: 'center' } }} id="outlined-basic" disabled type="date" name="createdDate" value={(updateTagDetails.createdDate).split("T")[0]} size="small" label="" variant="outlined" />

                                            </TableCell>
                                        </TableRow>
                                   
                                         <TableRow>
                                            <TableCell align="center" component="th" scope="row">
                                                Customer Registration No
                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField fullWidth inputProps={{style: { textAlign: 'center' }}}  id="outlined-basic" disabled name="customerNo" value={tagDetails.customerNo} size="small" label="" variant="outlined" />

                                            </TableCell>
                                            <TableCell classes={classes.autoComplete} >

                                            <TextField fullWidth inputProps={{style: { textAlign: 'center' }}}  id="outlined-basic" disabled name="customerNo" value={updateTagDetails.customerNo} size="small" label="" variant="outlined" />

                                            </TableCell>
                                        </TableRow>

                                        <TableRow>
                                            <TableCell  align="center" component="th" scope="row">
                                                Card No
                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField fullWidth inputProps={{style: { textAlign: 'center' }}} id="outlined-basic" disabled name="cardNo" value={tagDetails.cardNumber} size="small" label="" variant="outlined" />

                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField fullWidth inputProps={{style: { textAlign: 'center' }}} id="outlined-basic" disabled  name="cardNo" value={updateTagDetails.cardNumber} size="small" label="" variant="outlined" />
                                            </TableCell>
                                        </TableRow>

                                        <TableRow>
                                            <TableCell align="center" component="th" scope="row">
                                               Actual Amount
                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField fullWidth  type="number"  inputProps={{style: { textAlign: 'center' }}} disabled  id="outlined-basic"  name="actualAmount"  value={tagDetails.actualAmount}  size="small" label="" variant="outlined" />

                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField fullWidth  type="number"  inputProps={{style: { textAlign: 'center' }}}  disabled  id="outlined-basic" name="actualAmount"  value={updateTagDetails.actualAmount}  size="small" label="" variant="outlined" />
                                            </TableCell>
                                        </TableRow>
                                        
                                        <TableRow>
                                            <TableCell align="center" component="th" scope="row">
                                                Gross Weight
                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField fullWidth  type="number"  inputProps={{style: { textAlign: 'center' }}}  id="outlined-basic"  disabled name="grossWeight" value={tagDetails.grossAmount}  size="small" label="" variant="outlined" />

                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField fullWidth  type="number"  inputProps={{style: { textAlign: 'center' }}} id="outlined-basic" disabled name="grossAmount"  value={updateTagDetails.grossAmount} size="small" label="" variant="outlined" />
                                            </TableCell>
                                        </TableRow>

                                        

                                        <TableRow>
                                            <TableCell align="center" component="th" scope="row">
                                              Net Amount
                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField fullWidth  type="number"  inputProps={{style: { textAlign: 'center' }}}  id="outlined-basic" disabled name="netAmount"  value={tagDetails.netAmount}  size="small" label="" variant="outlined" />

                                            </TableCell>
                                            <TableCell align="center">
                                                <TextField fullWidth  type="number"  inputProps={{style: { textAlign: 'center' }}}  id="outlined-basic" name="netAmount" disabled  value={updateTagDetails.netAmount}  size="small" label="" variant="outlined" />
                                            </TableCell>
                                        </TableRow>

                                        <TableRow>
                                        <TableCell style={{background:"#f08080"}} colSpan={3} align="center" component="th" scope="row">
                                             Deductions
                                            </TableCell>
                                        </TableRow>

                                        {deductionTemplate.deductions.map((row) => (
                                            <TableRow key={row.name}>
                                                <TableCell align="center" component="th" scope="row">
                                                    {row.deductionTypeName}
                                                </TableCell>
                                                <TableCell align="center">
                                                    <TextField fullWidth type="number" disabled inputProps={{style: { textAlign: 'center' }}}  id="outlined-basic" size="small" value={row.deductionAmount} label="" variant="outlined" />

                                                </TableCell>
                                                <TableCell align="center">
                                                    <TextField fullWidth  type="number" disabled  inputProps={{style: { textAlign: 'center' }}} value={row.updatedAmount}  id="outlined-basic" size="small" label="" variant="outlined" />
                                                </TableCell>
                                            </TableRow>
                                        ))}

                                    </TableBody>
                                </Table>
                            </TableContainer>

                    </CardContent>
                <CardActions className={classes.card} alignContent={'right'} hidden={viewTable}>
                    <Grid container justify="flex-end" >
                        <Button
                             onClick={() => handleApprove()}
                            variant="contained"
                            className={classes.btnroot}
                        > Approve</Button>&nbsp;
                         <Button
                             onClick={() => handleReject()}
                            variant="contained"
                            className={classes.btnrootReject}
                        > Reject</Button>&nbsp;
                    </Grid>

                </CardActions>

                <MessageModal
                        hidden={messageModel.hidden}
                        messageType={messageModel.type}
                        messageDescription={messageModel.disciption}
                        clicked={modalDismissHandler}
                    />
                </Card>
           
               


        </Fragment>
    );
}